import styled from "styled-components";

export const Container = styled.div`
  text-align: center;
  border-radius: 16px;
  border: 1px solid ${props => props.theme.gray250};
  padding: 32px;

  .vip-icon {
    position: absolute;
    bottom: -8px;
    left: 50%;
    transform: translateX(-50%);
  }

  .agencies-avatar {
    width: 88px;
    min-width: 88px;
    max-width: 88px;
    height: 88px;
    object-fit: contain;
  }

  &:hover {
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.12);

    .show-agency-page-btn {
      color: #ffffff;
      background-color: ${props => props.theme.primary};
      border-color: ${props => props.theme.primary};
    }
  }

  @media (max-width: ${props => props.theme.screenSmMax}) {
    display: flex;
    align-items: center;
    text-align: right;
    border-radius: 0;
    border: 0;
    border-bottom: 1px solid ${props => props.theme.gray200};
    padding: 24px 0;

    .agencies-avatar {
      width: 56px;
      min-width: 56px;
      max-width: 56px;
      height: 56px;
    }

    &:hover {
      box-shadow: none;
    }

    .chevron-left-icon-link {
      svg {
        path {
          stroke-width: 1.2;
        }
      }
    }
  }

  .skeleton-parent {
    & > span {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

export const Title = styled.h3`
  font-size: 16px !important;

  @media (max-width: ${props => props.theme.screenSmMax}) {
    font-size: 15px !important;
  }
`;

export const Info = styled.div`

  .realtor-name {
    text-align: center;
  }

  @media (max-width: ${props => props.theme.screenSmMax}) {
    width: calc(100% - 112px);

    .realtor-name {
      text-align: right;
    }

    * {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
`;

export const StarsCard = styled.div`
  display: inherit;

  .icons {
    margin-right: 3px;
    width: 14px;

    &:first-child {
      margin-right: 0;
    }
  }
`;

export const Rate = styled.span`
  font-size: 12px;
  font-weight: normal;
  line-height: 1.58;
  color: ${props => props.theme.black};
`;

export const Address = styled.address`
  min-height: 27px;

  &.skeleton-parent {
    min-height: auto;
  }

  @media (max-width: ${props => props.theme.screenSmMax}) {
    span {
      font-size: 14px;
    }
  }
`;